/* eslint-disable react/no-unescaped-entities */
import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

// import TempModal from "@src/routes/[courseId]/[tabId]/TempModalComponent";
import Popup from "@src/components/UIElements/Popup";
import Button from "@src/components/UIElements/Button/index";

import { Image } from "@src/components/Image";
import { getAwsAssets } from "@src/utils";

import {
  applyCourseCouponAction,
  applyCouponFakeLoading,
  getGraphCoursePriceDetailsAction,
  handleShowCouponAppliedPopup,
  getGraphCourseCouponsAction,
  removeCourseCouponAction,
  setCouponCodeAction,
} from "@src/components/Tabs/Overview/store/actions";
import { useRouter } from "@src/lib/router";
import { t } from "i18next";

function CouponAppliedSuccess() {
  const showApplyCouponPopup = useSelector(
    (state) => state?.overviewReducer?.showApplyCouponPopup
  );

  const currentCouponCode = useSelector(
    (state) => state?.overviewReducer?.currentCouponCode
  );

  const router = useRouter();

  const dispatch = useDispatch();

  const graphCouponListData = useSelector(
    (state) => state?.overviewReducer?.graphCourseCouponListData
  );
  const isMoneyBack = useSelector((state) => state?.overviewReducer?.moneyBackGuarantee?.addOnOptionId) || 0;

  const graphCouponList = graphCouponListData?.coupons;

  let studentCouponList = graphCouponList ? [...graphCouponList] : [];
  const autopayConfigId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig?.id || null
  );

  let setTimeoutRef = useRef();
  useEffect(() => {
    return () => {
      stopCountdown();
    };
  }, []);

  const stopCountdown = () => {
    clearInterval(setTimeoutRef.current);
  };

  const handleDoneClick = () => {
    stopCountdown();
    dispatch(
      getGraphCoursePriceDetailsAction({
        courseIds: [`${router.query.courseId}`],
        isBundlingCourse: false,
        avoidCouponsList: true,
        optedAddOn:isMoneyBack,
        autopayConfigId :  autopayConfigId || null,
      })
    );

    dispatch(
      getGraphCourseCouponsAction({
        variables: {
          courseId: `${router.query.courseId}`,
          limit: 20,
          offset: 0,
        },
      })
    );
    dispatch(handleShowCouponAppliedPopup(false));
  };

  useEffect(() => {
    // if (showApplyCouponPopup && !pricingSections) {
    if (showApplyCouponPopup) {
      setTimeoutRef.current = setTimeout(handleDoneClick, 2000);
    }
  }, [showApplyCouponPopup]);

  return (
    <Popup
      showPopup={showApplyCouponPopup}
      handleClose={() => {
        handleShowCouponAppliedPopup(false);
      }}
    >
      <div className="couponsAppliedPopup">
        <Image
          src={getAwsAssets("CouponSuccess.gif", "Overview")}
          className="GIFCoupons"
          width="80"
          height="80"
        />
        <div className="couponSuccessApplied">
          {t(
            "components.BottomSheets.components.CouponAppliedSuccess.index.couponAppliedText",
            "Coupon code Applied!"
          )}
        </div>
        <div className="couponSuccessAppliedText">
          {t(
            "components.BottomSheets.components.CouponAppliedSuccess.index.yourCouponText",
            "Your coupon"
          )}{" "}
          <span>
            {`"`}
            {currentCouponCode?.code}
            {`"`}
          </span>{" "}
          {t(
            "components.BottomSheets.components.CouponAppliedSuccess.index.appliedText",
            "has been successfully applied."
          )}
        </div>
        <Button
          className="viewALLBtnMobile"
          onClick={() => {
            //   dispatch(applyCouponFakeLoading());
            handleDoneClick();
          }}
          style={{ marginTop: "25px", fontWeight: "600" }}
          // outline
        >
          {t(
            "components.BottomSheets.components.CouponAppliedSuccess.index.doneText",
            "Done"
          )}
        </Button>
      </div>
    </Popup>
  );
}

export default CouponAppliedSuccess;
